import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'mobileMenu']

  toggle() {
    this.mobileMenuTarget.classList.toggle('hidden')
  }
}
